export enum AnalyticsEvent {
  // Authentication Events
  loginGetOtPTap = "login_get_otp_tap",
  loginGetOTPError = "login_get_otp_error",
  loginVerifyOtpTap = "login_verify_otp_tap",
  loginVerifyOtpError = "login_verify_otp_error",
  logoutTap = "logout_tap",

  // Profile Screen Events
  profilePrivacyPolicyTap = "profile_privacy_policy_tap",
  profileTermsOfServiceTap = "profile_terms_of_service_tap",

  // Booking Summary Events
  bookingTry = "booking_try",
  bookingSuccess = "booking_success",
  bookingError = "booking_error",

  // Waitlist Events
  joinWaitlistTap = "join_waitlist_tap",
  joinWaitlistSuccess = "join_waitlist_success",
  joinWaitlistError = "join_waitlist_error",
  waitlistBookingDetailShareBookingTap = "waitlist_booking_detail_share_booking_tap",

  // User Home Tab Events
  viewHomeScreen = "view_home_screen",
  businessDetailTap = "business_detail_tap",

  // Business Detail Events
  shareBusinessTap = "business_detail_share_business_tap",
  messageBusinessTap = "business_detail_message_business_tap",
  bookServiceTap = "book_service_tap",

  // Booking Detail Events
  bookingDetailCancelBookingTap = "booking_detail_cancel_booking_tap",
  bookingDetailShareBookingTap = "booking_detail_share_booking_tap",
  bookingDetailDownloadInvoiceTap = "booking_detail_download_invoice_tap",

  // Membership Purchase Events
  buyMembershipTap = "buy_membership_tap",
  buyMembershipSuccess = "buy_membership_success",
  buyMembershipError = "buy_membership_error",

  // Rate Business Events
  rateYourBusinessExperiencePrompt = "rate_your_business_experience_prompt",
  rateBusinessExperienceSubmit = "rate_business_experience_submit",

  // Business Home Events
  businessHomeClientsTap = "business_home_clients_tap",
  businessHomeMembershipsTap = "business_home_memberships_tap",
  businessHomeBookingsTap = "business_home_bookings_tap",
  businessHomeWaitlistBookingsTap = "business_home_waitlist_bookings_tap",

  // Business Bookings Events
  businessBookingsAddBookingTap = "business_bookings_add_booking_tap",
  businessBookingRequestsTap = "business_booking_requests_tap",

  // Edit Business Events
  deleteBusiness = "delete_business",
  leaveBusiness = "leave_business",
  addClientTap = "add_client_tap",

  // WhatsApp Alert Events
  whatsappAlertTry = "whatsapp_alert_try",
  whatsappAlertSuccess = "whatsapp_alert_success",
  whatsappAlertError = "whatsapp_alert_error",

  // Business Calendar Events
  deleteCalendar = "delete_calendar",
  addCalendarTap = "add_calendar_tap",

  // Biiling Events
  billingWarningTap = "billing_warning_tap",
  billingHistoryTap = "billing_history_tap",

  // Biiling- Subscription
  billingSubscribeNowTap = "billing_subscribe_now_tap",
  billingSubscribeTry = "billing_subscribe_try",
  billingSubscribeSuccess = "billing_subscribe_success",
  billingSubscribeError = "billing_subscribe_error",

  // Biiling - Subscription Payment
  billingPaymentSuccess = "billing_payment_success",
  billingPaymentError = "billing_payment_error",
}
